import React from "react";

const Job = () => {
  return (
    <div
      className="container-fluid py-5 d-flex align-items-center justify-content-center"
      style={{ backgroundColor: '#fff', minHeight: "300px" }}
    >
      <div
        className="text-center p-4 rounded "
        style={{ maxWidth: "500px" }}
      >
        <div
          className="mb-4"
          style={{ fontSize: "60px", color: 'var(--bs-primary)' }}
          aria-hidden="true"
        >
          {/* Info icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="currentColor"
            className="bi bi-info-circle"
            viewBox="0 0 16 16"
          >
            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .875-.252 1.02-.598l.088-.416c.073-.342.029-.461-.214-.58l-.451-.217c-.262-.13-.343-.243-.293-.55l.007-.074c.027-.297.184-.386.529-.386h.205l.088-.445zm-.812-2.593c-.27 0-.484.207-.484.462 0 .256.213.463.484.463.271 0 .484-.207.484-.463 0-.255-.213-.462-.484-.462z" />
          </svg>
        </div>
        <h1 style={{ color: 'var(--bs-primary)', fontWeight: "700" }}>No Jobs Available</h1>
        <p style={{ fontSize: "18px", color: "#555", marginTop: "10px" }}>
          Sorry, there are currently no job openings. Please check back later or
          explore other opportunities.
        </p>
      </div>
    </div>
  );
};

export default Job;
